// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Ranking__ranking_number___3ZQWS{line-height:normal}", ""]);
// Exports
exports.locals = {
	"ranking_number": "Ranking__ranking_number___3ZQWS"
};
module.exports = exports;
